import { Alert, AlertColor, Autocomplete, Box, Button, CircularProgress, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Tooltip, Typography, useTheme } from '@mui/material';
import { ReactNode, useEffect, useRef, useState } from 'react';
import { useApi } from '../../services/HttpService';
import { InfoArea } from '../../components/ui/InfoArea';
// import { createMenuitemHirarchy, countHierarchyChildren, Menuitem, newMenuitem } from '../../model/System';
import { HourRegistration, newHourRegistration, createHourRegistrionsList, Project, createProjectList} from '../../model/Hour';
import HardDeleteDialog from '../../components/modals/dialog/HardDeleteDialog';
import { CenterSpinner } from '../../components/ui/CenterSpinner';
import DeleteIcon from '@mui/icons-material/Delete';
import React from 'react';
import { SingleDatePicker } from '../../components/ui/SingleDatePicker';
import { ClickableIcon } from '../../components/ui/Icon';
import EditIcon from '@mui/icons-material/Edit';
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';
import { NumberFormat } from '../../components/ui/NumberFormat';

export const MyHours = () => {
  const theme = useTheme();
  // const { api, error, isLoading } = useApi();
  const { api: hourRegistrationsApi, response: hourRegistrationsResponse, isLoading: hourRegistrationsIsLoading, error: hourRegistrationsError } = useApi();
  const { api: saveHourRegApi, response: saveHourRegResponse, isLoading: saveHourRegIsLoading, error: saveHourRegError } = useApi();
  const { api: deleteHourRegApi, response: deleteHourRegResponse, isLoading: deleteHourRegIsLoading, error: deleteHourRegError } = useApi();
  const [hourRegistration, setHourRegistration] = useState<HourRegistration>(newHourRegistration);
  const [selectedProject, setSelectedProject] = useState<Project>();
  const [selected, setSelected] = useState<HourRegistration>({} as HourRegistration); // item to be deleted
  const [openDelete, setOpenDelete] = useState(false);
  const [hourRegistrations, setHourRegistrations] = useState<HourRegistration[]>([]);
  const [hourRegistrationsAccepted, setHourRegistrationsApproved] = useState<HourRegistration[]>([]);
  const [hourRegistrationsHistory, setHourRegistrationsHistory] = useState<HourRegistration[]>([]);
  const [projectList, setProjectList] = useState<Project[]>([]);
  const [touched, setTouched] = useState<{ [key: string]: boolean }>({}); // track edited fields
  const [submitted, setSubmitted] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState<AlertColor | undefined>('error');

  const editRef = useRef(null); // scroll to edit on edit click
  const executeScroll = () => editRef.current.scrollIntoView();

  useEffect(() => {
    getHours();
  }, []);

  const getHours = () => {
    hourRegistrationsApi("/hour/getHourRegistrations").then(res => {
      if (res && res.statusCode === 200) {
        setHourRegistrations(res.data.myhours)
        setProjectList(res.data.projects)
      }
    });
  }

  const projectMap = React.useMemo(() => {
    const map = {};
    projectList.forEach(project => {
      map[project.id] = project; // You can map the whole project if needed
    });
    return map;
  }, [projectList]);

  const postHourRegistration = async () => {
    const hasErrors = Object.keys(hourRegistration).some(
      (key) => validateField(key as keyof HourRegistration) !== ""
    );

    if (!hasErrors) {
      await saveHourRegApi("/hour/postHourRegistration", "POST", { ...hourRegistration}).then(res => {
        if (res && res.statusCode === 200) {
          setHourRegistration(newHourRegistration);
          getHours();
          setSubmitted(false);
          toggleEditing();
        }else{
          if (res.error) {
            if (res.error.code === "1") {
              setDisplayMessage("Feil under kontakt med Winorg");
            } else if (res.error.code === "2") {
              setDisplayMessage("Ingen endringner funnet");
            } else if (res.error.code === "3") {
              setDisplayMessage("Ved endring av medlemsstatus ber vi om utfyllende informasjon i fritekstfeltet.");
            } else if (res.error.code === "4") {
              setDisplayMessage("Feil under kontakt med Winorg");
            } else {
              setDisplayMessage("Feil under oppdatering, prøv igjen");
            }
          }
        }
      });
    } else {
      setSubmitted(true);
    }
  }

  const setDisplayMessage = (message: string, type: AlertColor = 'error') => {
    setMessage(message);
    setMessageType(type);
  }

  // const handleNewRegistration = () =>{
  //   setSelectedProject(null);
  //   setHourRegistration(newHourRegistration);
  //   toggleEditing();
  // }

  const handleEditRegistration = (event, item) =>{
    event.stopPropagation();
    setSelectedProject(projectMap[item.hour_project_id]);
    setHourRegistration(item);
    toggleEditing();
  }


  const toggleEditing = () => {
    setIsEditing(!isEditing);
  };

  const deleteHourRegistration = () => {
    deleteHourRegApi("/hour/deleteHourRegistration", "POST", { ...hourRegistration }).then(res => {
      if (res && res.statusCode === 200) {
        setSelected({} as HourRegistration);
        setOpenDelete(false);
        getHours();
      }
    });
  }

  const handleDeleteClick = (event, registration) => {
    event.stopPropagation();
    setSelected(registration);
    setOpenDelete(true);
  }

  const handleChange = (field: keyof HourRegistration, value: string) => {
    setHourRegistration((prev) => ({ ...prev, [field]: value }));

    if (!touched[field]) {
      setTouched((prev) => ({ ...prev, [field]: true }));
    }
  };

  // const handleNumberChange = (field: keyof HourRegistration, value: number) => {
  //   setHourRegistration((prev) => ({ ...prev, [field]: value }));

  //   if (!touched[field]) {
  //     setTouched((prev) => ({ ...prev, [field]: true }));
  //   }
  // };

  const handleProjectChange = (event: React.SyntheticEvent, newValue: Project | null) => {
    if (newValue) {
      setSelectedProject(newValue);
      setHourRegistration((prev) => ({
        ...prev,
        hour_project_id: newValue.id, // Set the selected project's ID
      }));
    } else {
      setSelectedProject(null);
      setHourRegistration((prev) => ({
        ...prev,
        hour_project_id: 0, // Reset to default if no project is selected
      }));
    }
  };

  const handleSetHour = (amount) => {
    setHourRegistration((prev) => ({
        ...prev,
        hour: amount,
    }));
  };

  const handleHourChange = (event) => {
    const value = parseFloat(event.target.value);
    if (!isNaN(value) && value % 0.5 === 0) {
        setHourRegistration((prev) => ({
            ...prev,
            hour: value,
        }));
    }
};

const handleIncrement = (amount) => {
  setHourRegistration((prev) => ({
      ...prev,
      hour: Math.max(0, parseFloat((prev.hour + amount).toFixed(1))),
  }));
};

  /**
   * Unified error validation function.
   * @param field - The name of the field to validate.
   * @returns An error message if validation fails, or an empty string if valid.
   */
  const validateField = (field: keyof HourRegistration): string => {
    if (field === "hour_project_id") {
      if (hourRegistration.hour_project_id === 0) return "Required";
    }
    if (field === "hour"){
      if (hourRegistration.hour === 0) return "Required"
    }
    if (field === "name") {
      if (hourRegistration.name.trim() === "") return "Description cannot be empty";
      if (hourRegistration.name.trim().length < 5) return "Description must be at least 5 characters long";
    }
    if (field === "hour_project_id"){
      if (hourRegistration.hour_project_id == 0) return "required"
    }

    return ""; // No error
  };

  return (
    <>
      <HardDeleteDialog
        open={openDelete}
        bodyText={`Er du sikker på at du vil slette timeregistrering for "${projectMap[selected.hour_project_id]?.name || 'dette prosjektet'}"? Trykk på "SLETT" for å bekrefte.`}
        // bodyText={`Are you sure you want to delete hour registration for "${projectMap[selected.hour_project_id]?.name || 'this project'}" ? Click "DELETE" to confirm.`}
        loading={deleteHourRegIsLoading}
        errorMessage={deleteHourRegError}
        onClose={() => setOpenDelete(false)}
        onConfirm={() => deleteHourRegistration()}
      />

      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 2 }}>
        {/* <Typography variant='h5' sx={{ mt: 2 }}>Menu settings</Typography> */}

        {hourRegistrationsError && <Alert sx={{ width: "100%" }} severity="error">{hourRegistrationsError}</Alert>}

        {isEditing && (
        <Box id="edit-box" ref={editRef} sx={{ width: "100%" }}>
          <InfoArea title={hourRegistration.id > 0 ? "Endre timeregistrering" : "Registrer time"}>
            <Autocomplete
              aria-required
              disablePortal
              options={projectList} // List of projects
              getOptionLabel={(option) => option.name} // Display project name
              renderInput={(params) => <TextField {...params} label="Velg prosjekt" />}
              onChange={handleProjectChange} // Handle project selection
              value={selectedProject}
              // sx={{ width: 300 }}
              // renderInput={(params) => <TextField {...params} label="Project" />}
            />
            <Box display="flex" alignItems="center" gap={1}  flexWrap="wrap">
            <TextField
              label="Timer"
              type="number"
              value={hourRegistration.hour}
              onChange={handleHourChange}
              inputProps={{
                  step: "0.5",
                  min: 0,
              }}
              // sx={{ width: 120, textAlign: 'center' }}
              sx={{
                width: { xs: '100%', sm: 120 }, // Full width on small screens, 120px on larger screens
                textAlign: 'center',
            }}
            />
            <Button 
                onClick={() => handleSetHour(8)} 
                sx={{ fontSize: { xs: '0.75rem', sm: '1rem' }, padding: { xs: '4px 8px', sm: '6px 12px' } }}
            >
                8 timer
            </Button>
            <Button 
                variant="contained" 
                onClick={() => handleIncrement(1)} 
                sx={{ fontSize: { xs: '0.75rem', sm: '1rem' }, padding: { xs: '4px 8px', sm: '6px 12px' } }}
            >
                + 1
            </Button>
            <Button 
                variant="contained" 
                onClick={() => handleIncrement(0.5)} 
                sx={{ fontSize: { xs: '0.75rem', sm: '1rem' }, padding: { xs: '4px 8px', sm: '6px 12px' } }}
            >
                + 0,5
            </Button>
            <Button 
                variant="contained" 
                onClick={() => handleIncrement(-0.5)} 
                sx={{ fontSize: { xs: '0.75rem', sm: '1rem' }, padding: { xs: '4px 8px', sm: '6px 12px' } }}
            >
                - 0,5
            </Button>
            <Button 
                variant="contained" 
                onClick={() => handleIncrement(-1)} 
                sx={{ fontSize: { xs: '0.75rem', sm: '1rem' }, padding: { xs: '4px 8px', sm: '6px 12px' } }}
            >
                - 1
            </Button>
            </Box>
            <TextField
              label="Beskrivelse"
              required
              multiline
              rows={2}
              value={hourRegistration.name}
              onChange={(e) => handleChange("name", e.target.value)}
              variant="filled"
              error={validateField("name") !== "" && (submitted || touched.description)}
              helperText={(submitted || touched.description) ? validateField("name") : ""}
              onBlur={() => setTouched((prev) => ({ ...prev, description: true }))}
            />
            <SingleDatePicker
              label="Dato"
              date={hourRegistration.hour_date}
              onChange={(date) => setHourRegistration({ ...hourRegistration, hour_date: date })}
            />

            <Box sx={{ width: '100%', display: 'flex', justifyContent: 'end', flexWrap: 'wrap', gap: 2, p: 2 }}>
              <Button
                variant='contained'
                color='darkgrey'
                onClick={() => {
                  setHourRegistration(newHourRegistration);
                  setTouched({});
                  setSubmitted(false);
                  toggleEditing();
                }}
              >
                Avbryt
              </Button>
              <Button
                variant='contained'
                color='info'
                onClick={postHourRegistration}
                disabled={saveHourRegIsLoading}
                endIcon={saveHourRegIsLoading && <CircularProgress size={22} />}
              >
                {hourRegistration.id > 0 ? "Lagre" : "Opprett"}
              </Button>
            </Box>
          </InfoArea>
        </Box>
        )}

        <InfoArea title='Mine timer'>
          <CenterSpinner loading={hourRegistrationsIsLoading} />
          {!hourRegistrationsIsLoading && (
            <>
              {hourRegistrations?.length > 0 ? (
                <TableContainer component={Paper} sx={{ mt: 2 }}>
                  <Table>
                      <TableHead>
                          <TableRow>
                              <TableCell><Typography variant="body1">Dato</Typography></TableCell>
                              <TableCell><Typography variant="body1">Prosjekt</Typography></TableCell>
                              <TableCell><Typography variant="body1">Timer</Typography></TableCell>
                              <TableCell><Typography variant="body1"></Typography></TableCell>
                          </TableRow>
                      </TableHead>
                      <TableBody>
                          {hourRegistrations?.map((item, index) => (
                              <TableRow key={index} hover onClick={() => setHourRegistration(item)}>
                                  <TableCell>{new Date(item.hour_date).toLocaleDateString('da-NO')}</TableCell>
                                  <Tooltip title={item.name || ''} arrow>
                                      <TableCell>{projectMap[item.hour_project_id].name || "Ukjent prosjekt"}</TableCell>
                                  </Tooltip>
                                  <TableCell>{NumberFormat(item.hour).toString()}</TableCell>
                                  <TableCell>
                                      <IconButton title="Endre" onClick={(event) => handleEditRegistration(event, item)}>
                                          <EditIcon color='inherit' />
                                      </IconButton>
                                      <IconButton title="Slett" onClick={(event) => handleDeleteClick(event, item)}>
                                          <DeleteIcon color='error' />
                                      </IconButton>
                                  </TableCell>
                              </TableRow>
                          ))}
                      </TableBody>
                  </Table>
                </TableContainer>
              ) : (
                <>
                  <Alert severity='warning'>Ingen timeregistreringer</Alert>
                </>
              )}
              
            </>
          )}
        </InfoArea>
      </Box>
    </>
  )
}